import Vue from 'vue'

// Element UI
import Element from 'element-ui'

// size: default/medium/small/mini
// Vue.use(Element, { size: 'small', zIndex: 3000 })
Vue.use(Element, { size: 'small' })
